<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {
    
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
#app {
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  width: 100vw;
}
body {
  height: 100vh;
  width: 100vw;
}
</style>
